import React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";

type Props = {
  onPress: () => void;
  size?: number;
  lineLength?: number;
  lineThickness?: number;
};

export default function CreateMeetingButton({
  onPress,
  size = 78,
  lineLength = 43,
  lineThickness = 7,
}: Props) {
  const iconOffset = (lineLength - lineThickness) / 2;

  return (
    <TouchableOpacity
      style={[
        styles.addButton,
        { width: size, height: size, borderRadius: size / 2 },
      ]}
      onPress={onPress}
    >
      <View
        style={[styles.plusIcon, { width: lineLength, height: lineLength }]}
      >
        <View
          style={[
            styles.plusVertical,
            { width: lineThickness, height: lineLength, left: iconOffset },
          ]}
        />
        <View
          style={[
            styles.plusHorizontal,
            { width: lineLength, height: lineThickness, top: iconOffset },
          ]}
        />
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  addButton: {
    backgroundColor: "#3A6FB1",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 40,
  },
  plusIcon: {
    position: "relative",
  },
  plusVertical: {
    position: "absolute",
    backgroundColor: "#F6F7F9",
    borderRadius: 50,
    top: 0,
  },
  plusHorizontal: {
    position: "absolute",
    backgroundColor: "#F6F7F9",
    borderRadius: 50,
    left: 0,
  },
});
